// extracted by mini-css-extract-plugin
module.exports = {"groupname":"SelectedGroupModal_groupname_aePoe"};